module.exports = __webpack_public_path__ + "media/space.2c555321.mp3";